import RequesterV1 from "@/components/api/v1/requester.js";

export default {

  fetchProviders(organization_id, agro_exporter_process_id, current_page, rows_per_page) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_process/${organization_id}/fetch_providers/${agro_exporter_process_id}/${current_page}/${rows_per_page}`
    );
  },

  fetchTotalProviders(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_process/${organization_id}/fetch_total_providers/${agro_exporter_process_id}`
    );
  },

  fetchAgroExporterProcess(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_process/${organization_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchSummary(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_process/${organization_id}/fetch_summary/${agro_exporter_process_id}`
    );
  },

  fetchProvidersSummary(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_process/${organization_id}/fetch_providers_summary/${agro_exporter_process_id}`
    );
  },

  fetchCropSizeSummary(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_process/${organization_id}/fetch_crop_size_summary/${agro_exporter_process_id}`
    );
  },

  fetchCropSizesByProducer(organization_id, agro_exporter_process_id, crop_size_id) {
    return RequesterV1.get(
      `organization/production/query_by_provider/show_process/${organization_id}/fetch_crop_size_by_provider/${agro_exporter_process_id}/${crop_size_id}`
    );
  }
}
